module.exports = __webpack_public_path__ + "static/media/MZ.aff3b04a.svg";